import { createClient } from "@/lib/supabase/client";

let sessionCache: { token: string; expiresAt: number } | null = null;

async function getAccessToken() {
  if (sessionCache && Date.now() < sessionCache.expiresAt) {
    return sessionCache.token;
  }

  const supabase = createClient();
  const {
    data: { session },
  } = await supabase.auth.getSession();

  const token = session?.access_token;
  if (token) {
    sessionCache = { token, expiresAt: Date.now() + 55_000 };
  } else {
    sessionCache = null;
  }
  return token;
}

export function clearSessionCache() {
  sessionCache = null;
}

/** Same-origin API fetch with Supabase session (cookies + Bearer token). */
export async function fetchWithAuth(input: RequestInfo | URL, init: RequestInit = {}) {
  const token = await getAccessToken();

  const headers = new Headers(init.headers);
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return fetch(input, {
    ...init,
    credentials: "same-origin",
    headers,
  });
}

export async function parseJsonResponse<T = Record<string, unknown>>(response: Response): Promise<T> {
  const text = await response.text();
  if (!text.trim()) return {} as T;
  try {
    return JSON.parse(text) as T;
  } catch {
    return {} as T;
  }
}
